<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="ASP计划排产数据"></chart-title>
    <el-row id="center_2">
      <el-col :lg="8" :md="8" :sm="8" :xs="8">
        <div class="circlr_item">
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text">66%</span></dv-decoration-9
          >
          <div class="circlr_item_subtext">今日新线排产：1500㎡</div>
          <div class="circlr_item_subtext">今日老线排产：300㎡</div>
        </div>
      </el-col>
      <el-col :lg="8" :md="8" :sm="8" :xs="8"
        ><div class="circlr_item">
          <div class="circlr_item_subtext">未排产：1500㎡</div>
          <div class="circlr_item_subtext">今日排产：300㎡</div>
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text">30%</span></dv-decoration-9
          >
        </div>
      </el-col>
      <el-col :lg="8" :md="8" :sm="8" :xs="8"
        ><div class="circlr_item">
          <dv-decoration-9 class="circlr"
            ><span class="circlr_text">88%</span></dv-decoration-9
          >
          <div class="circlr_item_subtext">新线流程卡：1500㎡</div>
          <div class="circlr_item_subtext">老线流程卡：300㎡</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
export default {
  mixins: [resize],
  name: "center_2",
  components: { ChartTitle },
  data() {
    return {};
  },
  props: {},
  created() {},
  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 27vh; 
  #center_2 {
    height: calc(100% - 30px);
    padding: 0 22px;
    .circlr_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      .circlr {
        height: 120px;
        width: 120px;
        margin-bottom: 16px;
        .circlr_text {
          color: #DCDFE6;
          font-size: 24px;
          font-weight: bold;
        }
      }
      .circlr_item_subtext {
        color: #EBEEF5;
        margin-bottom: 6px;
        font-weight: bold;
      }
    }
  }
}
</style>
